import configuration from "../../config/Config";

export function withCdn(url) {
  if (!url || typeof url !== "string") return url;
  const cdn = (configuration.cdnFront || "").replace(/\/$/, "");

  // S3 URL → CloudFront
  if (cdn && url.includes(".amazonaws.com/")) {
    const path = url.split(".amazonaws.com/")[1];
    return `${cdn}/${path}`;
  }

  // Any other full URL (including legacy localhost /uploads/) — use as-is
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("//")) return url;

  // Relative path — prefix with CDN or API base
  const base = (cdn || configuration.apiUrl || "").replace(/\/$/, "");
  const path = url.startsWith("/") ? url.slice(1) : url;
  return base ? `${base}/${path}` : url;
}

export const inputSx = {
  "& .MuiOutlinedInput-root": { borderRadius: "12px" },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#065F46" },
  "& .MuiInputLabel-root.Mui-focused": { color: "#065F46" },
};
